import React, { ReactElement, useEffect, useRef } from 'react';

import { FetchState } from 'src/enums/FetchState';

import TickSvg from 'public/icons/Tick.svg';

import { Button } from '../_Button/Button';

import styles from './ButtonWithLoader.module.css';

type ButtonWithLoaderProps = {
	id?: string;
	loginState?: FetchState;
	children?: ReactElement | string;
	className?: string;
	type?: 'button' | 'submit' | 'reset';
	disabled?: boolean;
	disableKeepWidth?: boolean;
	onSubmit?: (e: string) => void;
};

export function ButtonWithLoader(props: ButtonWithLoaderProps): JSX.Element {
	const btn = useRef<HTMLButtonElement>(null);

	const loginStates = Object.values(FetchState).filter((value) => typeof value === 'string') as string[];

	useEffect(() => {
		if (btn.current && props.disableKeepWidth) {
			btn.current.setAttribute('style', `width: ${btn.current.scrollWidth}px;`);
		}
	}, []);

	return (
		<Button
			id={props.id}
			type={props.type}
			title="Button Loader"
			buttonRef={btn}
			className={`${props.className} ${styles.button} ${styles[loginStates[props.loginState ? props.loginState : FetchState.START]]}`}
			disabled={props.disabled}
			onClick={(e) => props.onSubmit?.(e?.currentTarget.id || '')}
		>
			<div className={styles.contentWrapper}>{props.children}</div>

			<div className={styles.loaderWrapper}>
				<span className={styles.loader} />
			</div>

			<div className={styles.successWrapper}>
				<TickSvg />
			</div>
		</Button>
	);
}
